import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import jspdf from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class ViewReceiptsService {

  constructor(private httpClient: HttpClient, private router: Router) { }

//   getPdfForReceipt(receiptNo , id) {
//     const fileName = 'Receipt of' + receiptNo;
//     const data = document.getElementById(id)
// ;
//     html2canvas((data), { scale: 2 }).then(canvas => {

//   // Few necessary setting options

//   const pdf = new jspdf('p', 'px', 'a3'); // A4 size page of PDF
//   const imgWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = 295;
//   const imgHeight = pdf.internal.pageSize.getHeight();
//   const heightLeft = imgHeight;

//   const contentDataURL = canvas.toDataURL('image/jpeg');
//   const position = 0;
//   pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight);
//   pdf.save(fileName); // Generated PDF

// });
// }
getPdfForReceipt(receiptNo , id) {
  const fileName = 'Receipt of' + ' ' + receiptNo;
  const data = document.getElementById(id);
  (html2canvas as any)((data), { scale: 2 }).then(canvas => {

// Few necessary setting options

const pdf = new jspdf('p', 'px', 'a3'); // A4 size page of PDF
const imgWidth = pdf.internal.pageSize.getWidth();
const pageHeight = 295;
const imgHeight = pdf.internal.pageSize.getHeight();
const heightLeft = imgHeight;

const contentDataURL = canvas.toDataURL('image/jpeg');
const position = 0;
pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight);
pdf.save(fileName); // Generated PDF

});
}
getPdfForGenerate(receiptNo , id) {
  const fileName = 'Receipt of' + ' ' + receiptNo;
  const data = document.getElementById(id);
  (html2canvas as any)((data), { scale: 2 }).then(canvas => {

// Few necessary setting options

const pdf = new jspdf('p', 'px', 'a4'); // A4 size page of PDF
const imgWidth = pdf.internal.pageSize.getWidth();
const pageHeight = 295;
const imgHeight = pdf.internal.pageSize.getHeight();
const heightLeft = imgHeight;

const contentDataURL = canvas.toDataURL('image/jpeg');
const position = 0;
pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight);
pdf.save(fileName); // Generated PDF

});
}
}
